import {
  Tooltip as ChakraTooltip,
  type StyleProps,
  type ThemingProps,
} from '@chakra-ui/react';
import React from 'react';

type TooltipProps = {
  label: string;
  isDisabled?: boolean;
  hasArrow?: boolean;
  shouldWrapChildren?: boolean;
  children: React.ReactNode;
  placement?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-start'
    | 'top-end'
    | 'bottom-start'
    | 'bottom-end'
    | 'right-start'
    | 'right-end'
    | 'left-start'
    | 'left-end'
    | 'auto'
    | 'auto-start'
    | 'auto-end';
} & ThemingProps<'Tooltip'> &
  StyleProps;

const Tooltip = ({ children, ...props }: Readonly<TooltipProps>) => {
  return <ChakraTooltip {...props}>{children}</ChakraTooltip>;
};

export default Tooltip;
